import React from "react"
import PropTypes from "prop-types"

import VisibilitySensor from "react-visibility-sensor/visibility-sensor"
import VenueBox from "./VenueBox"

import style from "./index.module.sass"

export default function VenuesList({ orderMode, venues, onClick }) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function VisibleVenue({ index, venue, orderMode, onClick }) {
    return (
      <VisibilitySensor key={index} partialVisibility={true}>
        {({ isVisible }) => {
          return (
            <VenueBox
              key={index}
              isVisible={isVisible}
              orderMode={orderMode}
              venue={venue}
              onClick={onClick}
            />
          )
        }}
      </VisibilitySensor>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------
  return (
    // <div className="venues-list">
    <div className={style.container}>
      {venues.map((venue, index) => {
        return (
          <VisibleVenue
            key={index}
            index={index}
            venue={venue}
            orderMode={orderMode}
            onClick={onClick}
          />
        )
      })}
      {/* Prevent last line elements to grow without control */}
      {/* Actually the only working work-around to this flex lack */}
      <div className={style.lastCard}></div>
      <div className={style.lastCard}></div>
      <div className={style.lastCard}></div>
    </div>
  )
}

VenuesList.propTypes = {
  venues: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
}
